// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 897 ? "flipbook" : chunkId) + "." + {"194":"fd144ee9","511":"bd926fc5","684":"bd926fc5","897":"103b9bf1","918":"bd926fc5"}[chunkId] + ".css";
};